import { createUserManager } from 'redux-oidc';

const userManagerConfig = {
  client_id: 'bestige',
  redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/login`,
  response_type: 'token id_token',
  scope: 'openid api.asl email profile ascend.userid isf_api api.soa IdentityServerApi vbe_api',
  // eslint-disable-next-line no-undef
  authority: OIDC_AUTHORITY,
  filterProtocolClaims: true,
  loadUserInfo: true,
  monitorSession: true,
  automaticSilentRenew: true,
  silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/silent-renew.html`,
};

const userManager = createUserManager(userManagerConfig);

export default userManager;
